import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import { Button } from "../layer/wrapper";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import { getObjectPLC } from "../layer/reportBotPLC";
import { calReportAging } from "utils/calReportAging";
import { getFilterLoanBuro } from "components/BuroBug/BuroMainTwo";
import _ from "lodash";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ExportPLC({ loan = [], buroDate = new Date(), interest }) {
  const [loading, setLoading] = useState(false);
  const [plc, setPlc] = useState([]);
  const [countExport, setCountExport] = useState(0);

  useEffect(() => {
    if (plc.length > 0) {
      const getExportId = document.getElementById("export-excel-plc");
      getExportId.click();
    }
  }, [plc]);

  const onClickAging = async () => {
    try {
      setLoading(true);

      let { dataPrinciple: newLoans } = calReportAging(
        loan,
        new Date(buroDate)
      );

      // console.log("before", _.cloneDeep(newLoans.length));
      // console.log("interest", interest)

      // newLoans = getFilterLoanBuro(newLoans, buroDate, interest);

      // console.log("after", _.cloneDeep(newLoans.length));

      let keep = [];
      let index = 0;
      for (const itemLoan of newLoans) {
        if (index >= newLoans.length) {
          break;
        }
        const valuePlo = getObjectPLC(itemLoan, buroDate, true);
        keep.push(valuePlo);
        index++;
      }

      console.log("keep" ,keep);
      setPlc(keep);
      setCountExport(keep.length);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    // console.log(
    //   "hello",
    //   await getBase64FromUrl(
    //     "https://images.pexels.com/photos/1103970/pexels-photo-1103970.jpeg"
    //   )
    // );

    let style = { font: { sz: 14 }, alignment: "right", fill: filled_col_0 };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 = { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${data[i]["รหัสสถาบัน"] || ""}`,
          style,
        },
        {
          value: `${data[i]["งวดข้อมูล"] || ""}`,
          style,
        },
        {
          value: `${data[i]["รหัสของผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทรหัสของผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ชื่อผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["วันเกิดของผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ภาวะการทำงาน"] || ""}`,
          style,
        },
        {
          value: `${data[i]["อาชีพของผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["อาชีพของผู้กู้อื่น"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทธุรกิจของกิจการที่ผู้กู้ทำงาน"] || ""}`,
          style,
        },
        {
          value: `${data[i]["การพิจารณารายได้รวมของผู้บริโภค"] || ""}`,
          style,
        },
        {
          value: `${data[i]["รายได้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["เลขที่สัญญา"] || ""}`,
          style,
        },
        {
          value: `${data[i]["วันที่เริ่มสัญญา"] || ""}`,
          style,
        },
        {
          value: `${data[i]["วันที่สิ้นสุดสัญญา"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทสินเชื่อ"] || ""}`,
          style,
        },
        {
          value: `${data[i]["วัตถุประสงค์การกู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["วงเงินสินเชื่อ"] || ""}`,
          style,
        },
        {
          value: `${
            data[i][
              "อัตราดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียมใด ๆ"
            ] || ""
          }`,
          style,
        },
        {
          value: `${data[i]["หลักประกัน"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทรถ"] || ""}`,
          style,
        },
        {
          value: `${data[i]["มูลค่ารถ"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทสินเชื่อภายใต้การกำกับ"] || ""}`,
          style,
        },
        {
          value: `${data[i]["สินเชื่อดิจิทัล"] || ""}`,
          style,
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "รหัสสถาบัน",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "งวดข้อมูล",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "รหัสของผู้กู้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ประเภทรหัสของผู้กู้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ชื่อผู้กู้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "วันเกิดของผู้กู้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ภาวะการทำงาน",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "อาชีพของผู้กู้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "อาชีพของผู้กู้อื่น",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ประเภทธุรกิจของกิจการที่ผู้กู้ทำงาน",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "การพิจารณารายได้รวมของผู้บริโภค",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "รายได้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "เลขที่สัญญา",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "วันที่เริ่มสัญญา",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "วันที่สิ้นสุดสัญญา",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "วัตถุประสงค์การกู้",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "วงเงินสินเชื่อ",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "อัตราดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียมใด ๆ",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "หลักประกัน",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ประเภทรถ",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "มูลค่ารถ",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ประเภทสินเชื่อภายใต้การกำกับ",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "สินเชื่อดิจิทัล",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
      ],
      data: createDataWithStyle(plc),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`EXPORT_PLC_${format(new Date(buroDate), "yyyy-MM-dd")}`}
        element={<button id="export-excel-plc" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="PLC"></ExcelSheet>
      </ExcelFile>
      <Button disabled={loading || !loan.length} onClick={onClickAging}>
        {countExport > 0 && countExport} Export PLC
      </Button>
    </div>
  );
}

export default ExportPLC;
